




















































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import MyListExtends from "@/mixins/list-extends";

import moment from "moment";
import { getBillInfoMessageByAttr } from "@/libs/bill";
import Detail from "./components/xiaoyu-detail.vue";
import Total from "./components/total.vue";

@Component({ components: { Total, Detail } })
export default class extends Mixins(MyList, MyListExtends) {
  dispatchType = "groupXiaoyu/list";

  loading2: boolean = false;

  bill: any = {};

  editModalVisible = false;

  editId = 0;

  status: any = 0;

  total: any = {
    all: {},
    today: {}
  };

  fromSourceOptions: any[] = [
    {
      id: 4,
      name: "感知组局"
    }
  ];

  // 发送结果:1-等待发送；2-发送成功；3-发送失败
  statusOption: any[] = [
    {
      id: -1,
      name: "组局中",
      color: "#2db7f5",
      isValid: (obj: any) =>
        obj.bill_status == 1 && moment().isBefore(obj.valid_time_start)
    },
    {
      id: 1,
      name: "组局成功",
      color: "#87d068",
      isValid: (obj: any) =>
        obj.bill_status == 1 && moment().isAfter(obj.valid_time_start)
    },
    {
      id: 2,
      name: "组局失败",
      color: "red",
      isValid: (obj: any) => obj.bill_status == 2 || obj.bill_status == 3
    }
  ];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", dataIndex: "stadium_name" },
    // { title: "组局时间", dataIndex: "created_time" },
    // { title: "首次响应时间", dataIndex: "first_responed_time" },
    {
      title: "打球时间",
      // dataIndex: "valid_time_start",
      scopedSlots: { customRender: "valid_time_start" } 
    },

    {
      title: "付款时间",
      // dataIndex: "paid_time",
      scopedSlots: { customRender: "paid_time" }
    },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "来源", scopedSlots: { customRender: "from_source" } },
    {
      title: "总人数",
      // dataIndex: "join_count",
      scopedSlots: { customRender: "total_count" }
    },
    {
      title: "未响应人数",
      // dataIndex: "pending_count",
      scopedSlots: { customRender: "pending_count" }
    },
    {
      title: "应邀人数",
      // dataIndex: "join_count",
      scopedSlots: { customRender: "join_count" }
    },

    {
      title: "去不了人数",
      // dataIndex: "cancel_count",
      scopedSlots: { customRender: "cancel_count" }
    }
  ];

  mounted() {
    this.loadData();
    // 异常bug修复
    this.loading2 = true;
    this.fetchTotal(true);
    this.fetchTotal(false);
    this.loading2 = false;
  }

  formatData(rerord: any, attr: string) {
    return getBillInfoMessageByAttr(rerord, attr);
    // return d.format("YYYY-MM-DD HH:mm:ss");
  }

  totalCount(record: any) {
    return +record.join_count + +record.pending_count + +record.cancel_count;
  }

  handleDetail(record: any, iType: number) {
    this.editId = record.id;
    this.bill = record;
    this.editModalVisible = true;
  }

  fetchTotal(isToday: boolean) {
    this.$store
      .dispatch("groupXiaoyu/total", { is_today: isToday ? 1 : 0 })
      .then(data => {
        console.log("groupXiaoyu/total", data);

        if (isToday) {
          this.total.today = data.Data;
        } else {
          this.total.all = data.Data;
        }
      });
  }
}
